import { render, staticRenderFns } from "./IwsUpload.vue?vue&type=template&id=0c74ed22&scoped=true&"
import script from "./IwsUpload.vue?vue&type=script&lang=js&"
export * from "./IwsUpload.vue?vue&type=script&lang=js&"
import style0 from "./IwsUpload.vue?vue&type=style&index=0&lang=css&"
import style1 from "./IwsUpload.vue?vue&type=style&index=1&id=0c74ed22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c74ed22",
  null
  
)

export default component.exports